module.exports = __webpack_public_path__ + "img/8348c10.jpg";